<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { RestaurantsPath } from "../../../../path";
import add from "./add.vue";
import storeAdd from "../Restaurants/Stores/add.vue";
import BankInfo from "@/views/pages/Dilfoods/Restaurants/bank-info";
import Timings from "./timings.vue";
/* Dashboard component */
export default {
  components: {
    BankInfo,
    Layout,
    PageHeader,
    add: add,
    "store-add": storeAdd,
    Timings,
  },
  data() {
    return {
      title: "Restaurants",
      items: [
        {
          text: "List",
        },
        {
          text: "Restaurant",
          active: true,
        },
      ],
      key: 0,
      selectedRestaurant: {},
      restaurants: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      filter: [],
      currentPage: 1,
      search: "",
      fields: [
        { key: "name", thStyle: { width: "20%" } },
        "gst_number",
        { key: "address", thStyle: { width: "20%" } },
        "city",
        "state",
        "country",
        "zip_code",
        "bank_info",
        "status",
        "Actions",
      ],
    };
  },
  watch: {
    currentPage() {
      this.getRestaurants();
    },
    search() {
      this.getRestaurants();
    },
  },
  methods: {
    async setToggle(e, v) {
      try {
        let res = await axios.post(
          this.base_url + RestaurantsPath.STATUS_TOGGLE,
          {
            res_id: v.id,
            status: e,
          }
        );
        if (res.data.status) {
          this.$bvToast.toast("Successfully Updated", {
            title: `Status Updated`,
            variant: "success",
            solid: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    OpenTimings(v) {
      this.selectedRestaurant = v;
      this.$bvModal.show("add-timings");
    },
    updateBankInfo(v) {
      try {
        this.selectedRestaurant = v;
        this.$bvModal.show("bv-update-restaurant-bank-info");
      } catch (e) {
        console.log(e);
      }
    },
    async getRestaurants() {
      try {
        let response = await axios.get(
          this.base_url + RestaurantsPath.BASIC_RESTAURENT,
          {
            params: {
              page: this.currentPage,
              search: this.search,
            },
          }
        );
        if (response.data.status == true) {
          this.restaurants = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.selectedRestaurant = {};
      this.getRestaurants();
    },
    setEdit(d) {
      this.selectedRestaurant = d;
      this.$bvModal.show("bv-add-restaurant");
    },
    setStore(d) {
      this.selectedRestaurant = d;
      this.$bvModal.show("bv-add-store");
    },
    addRes() {
      this.$bvModal.show("bv-add-restaurant");
      this.selectedRestaurant = {};
      this.key += 1;
    },
    async deleteData(d) {
      try {
        let response = await axios.delete(
          this.base_url + RestaurantsPath.BASIC_RESTAURENT + "/" + d.id
        );
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Restaurant Deleted`,
            variant: "success",
            solid: true,
          });
          this.getRestaurants();
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getRestaurants();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addRes()" class="btn btn-primary mb-10 pb-10"
                  >Add Restaurant</b-button
                >
                <b-modal
                  id="bv-add-restaurant"
                  size="xl"
                  :title="
                    (Object.keys(selectedRestaurant).length > 0
                      ? 'Edit'
                      : 'Add') + ' Restaurant'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selectedRestaurant="selectedRestaurant"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-update-restaurant-bank-info"
                  size="xl"
                  title="Bank Info"
                  hide-footer
                >
                  <bank-info
                    @update="reload()"
                    :key="key"
                    :selectedRestaurant="selectedRestaurant"
                  ></bank-info>
                </b-modal>
                <b-modal
                  id="add-timings"
                  size="xl"
                  title="Restaurant Timings"
                  hide-footer
                >
                  <Timings
                    @update="reload()"
                    :key="key"
                    :res="selectedRestaurant"
                  ></Timings>
                </b-modal>
              </div>
              <b-sidebar
                id="add-store-sidebar"
                title="Add Location"
                backdrop-variant="dark"
                backdrop
                shadow
                right
                width="485px"
              >
                <store-add
                  @update="reload()"
                  :selectedRestaurant="selectedRestaurant"
                ></store-add>
              </b-sidebar>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      debounce="300"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                    <!-- <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> -->
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="restaurants.key"
                :items="restaurants.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(name)="row">
                  <img
                    src="@/assets/veg.png"
                    style="width: 25px"
                    v-if="row.item.food_type == 'veg'"
                  />
                  <img
                    src="@/assets/non_veg.png"
                    style="width: 20px"
                    v-if="row.item.food_type == 'non_veg'"
                  />
                  {{ row.item.name }}
                </template>
                <template v-slot:cell(bank_info)="row">
                  <i
                    v-if="row.item.bank_info"
                    class="fa fa-check-circle"
                    style="color: #1cbb8c"
                  ></i>
                  <i
                    v-else
                    class="fa fa-times-circle"
                    style="color: #c20414"
                  ></i>
                </template>
                <template v-slot:cell(status)="row">
                  <b-checkbox
                    switch
                    @change="setToggle($event, row.item)"
                    :checked="row.item.status == 1 ? true : false"
                  ></b-checkbox>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    class="mr-2"
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes('Restaurant') ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Info_Restaurant'
                      ).length ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0
                    "
                    @click="OpenTimings(row.item)"
                    variant="primary"
                    v-b-tooltip:hover
                    title="Update Timings"
                  >
                    <i class="fa fa-clock"></i>
                  </b-button>
                  <b-button
                    class="mr-2"
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes('RestaurantBank') ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Info_Restaurant'
                      ).length > 0 ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0
                    "
                    @click="updateBankInfo(row.item)"
                    variant="primary"
                    v-b-tooltip:hover
                    title="Update Bank Details"
                  >
                    <i class="fa fa-address-book"></i>
                  </b-button>
                  <b-button
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes('Restaurant') ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Info_Restaurant'
                      ).length > 0 ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0
                    "
                    class="mr-2"
                    v-b-toggle.add-store-sidebar
                    @click="setStore(row.item)"
                    variant="primary"
                    v-b-tooltip:hover
                    title="Add Location"
                  >
                    <i class="fa fa-map-marked"></i>
                  </b-button>
                  <b-button
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes('Restaurant') ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Info_Restaurant'
                      ).length > 0 ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0 ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Edit'
                      ).length
                    "
                    @click="setEdit(row.item)"
                    variant="primary"
                  >
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes('Restaurant') ||
                      $store.state.authfack.user.permissions.filter(
                        (f) => f.name == 'Bank_Info_Restaurant'
                      ).length > 0 ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0
                    "
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="restaurants.key"
                      v-model="currentPage"
                      :total-rows="restaurants.total"
                      :per-page="restaurants.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.custom-control-label::before {
  border: 1px solid #f11818;
}
.custom-switch .custom-control-label::after {
  background-color: #f11818;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #29a900;
  background-color: #29a900;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
</style>
